<template>
  <div class="webcam">
    <a :href="'#' + linkId" @click.prevent="openModal($event)">
      <img :src="src" :alt="altText" :id="linkId" />
      <div class="webcam-title o-65">{{ title }}</div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Webcam',
  props: ['webcam', 'webcamTitleField'],
  computed: {
    linkId() {
      return `${this.webcam.Title.replace(' ', '-')}-webcam-mobile`;
    },
    title() {
      return this.webcam[this.webcamTitleField];
    },
    altText() {
      return `View of conditions at ${this.webcam.Title}`;
    },
    src() {
      return this.webcam.ThumbnailUrl;
    },
    full_url() {
      return this.webcam.FullImageUrl;
    },
  },
  methods: {
    openModal(event) {
      this.$emit('showWebcamModal', this);
    },
  },
};
</script>

<style lang="scss" scoped>
.webcam {
  display: block;
  height: auto;
  float: left;
  margin-right: 1.5%;
  margin-bottom: 18px;
  overflow: hidden;
  width: 48.5%;
  @media (min-width: 1025px) {
    height: auto;
    width: 100%;
  }
  &:nth-child(2n) {
    margin-right: 0;
  }
  @media (min-width: $tablet-landscape) {
    height: auto;
    margin-right: 0;
    width: 100%;
  }
  a {
    color: $dark-gray;
    font-size: 12px;
    font-family: $base-font-regular;
    letter-spacing: 0;
    line-height: 1.2;
    text-decoration: none;
    @media (min-width: $tablet) {
      font-size: 14px;
    }
  }
  .webcam-title {
    margin-top: 5px;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (min-width: $tablet) {
    }
  }
}
</style>
